import { ReactElement } from 'react';
import { generatePath, Route } from 'react-router-dom';

import { createRouteConfig } from 'modules/common/utils/createRouteConfig';

import { DelegateStaking } from './screens/DelegateStaking';

const PATH = '/delegate-staking';

export const DelegateStakingRoutesConfig = createRouteConfig(
  {
    staking: {
      path: PATH,
      generatePath: () => generatePath(PATH),
    },
  },
  PATH,
);

export function getDelegateStakingRoutes(): ReactElement {
  return (
    <Route
      element={<DelegateStaking />}
      path={DelegateStakingRoutesConfig.staking.path}
    />
  );
}
